<template>
  <v-card
    @click="filterByCity"
    class="destination-card pointer"
    color="transparent"
    elevation="0"
  >
    <div class="destination-img-wrapper">
      <v-img
        class="destination-img"
        :src="
          cloudinaryDelivery(item.image, { width: 600 }) ||
          image(IMAGE_PLACEHOLDER)
        "
        aspect-ratio="1.34"
        cover
      >
        <template v-slot:placeholder>
          <div class="destination-img-placeholder"></div>
        </template>
        <div class="destination-img-gradient"></div>
        <div class="destination-title-overlay">
          <span class="destination-title">{{ item.name }}</span>
        </div>
      </v-img>
    </div>
  </v-card>
</template>

<script>
import { IMAGE_PLACEHOLDER } from "@/consts/CMS";
import MediaMixin from "@/mixins/media-mixin";

export default {
  name: "home-top-destinations-item",
  mixins: [MediaMixin],
  props: {
    item: {
      type: Object,
    },
  },
  data: () => ({ IMAGE_PLACEHOLDER }),
  methods: {
    filterByCity() {
      this.$router.push({
        name: "listings",
        query: {
          ...this.$route.query,
          city: this.item.name,
        },
      });
    },
  },
};
</script>

<style scoped>
.destination-card {
  border-radius: 20px;
  box-shadow: 0 4px 24px rgba(60, 60, 60, 0.1);
  overflow: hidden;
  transition: box-shadow 0.2s, transform 0.2s;
  cursor: pointer;
  min-height: 260px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.destination-card:hover {
  box-shadow: 0 8px 32px rgba(25, 118, 210, 0.18);
  transform: translateY(-2px) scale(1.03);
}
.destination-img-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 220px;
  display: flex;
  align-items: flex-end;
}
.destination-img {
  border-radius: 20px;
  min-height: 220px;
}
.destination-img-gradient {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 60%;
  background: linear-gradient(
    0deg,
    rgba(25, 118, 210, 0.65) 0%,
    rgba(25, 118, 210, 0) 100%
  );
  border-radius: 0 0 20px 20px;
  z-index: 1;
}
.destination-title-overlay {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 20px 20px 16px 20px;
  z-index: 2;
  display: flex;
  align-items: flex-end;
}
.destination-title {
  color: #fff;
  font-size: 1.25rem;
  font-weight: 700;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
  letter-spacing: -0.5px;
}
.destination-img-placeholder {
  background: #e3e8ee;
  width: 100%;
  height: 100%;
  border-radius: 20px;
}
</style>
